// extracted by mini-css-extract-plugin
export default {"ImageSnippet":"ImageSnippet_ImageSnippet__MGFiN"};